// Filter Tahun di modal Riwayat Cuti. Hak cuti berlaku per tahun kalender dan saldo tiap
// baris sudah dihitung per tahun di backend, jadi menyaring baris tak mengubah angka saldo.
export const SEMUA_TAHUN = "Semua";

export const tahunIni = () => String(new Date().getFullYear());

// TanggalMulai dari API berbentuk "YYYY-MM-DD..." — tahun = 4 karakter pertama.
const tahunCuti = (item) => String(item.TanggalMulai || "").slice(0, 4);

export function saringTahun(rows, tahun) {
  return tahun === SEMUA_TAHUN ? rows : rows.filter((r) => tahunCuti(r) === tahun);
}

export function pesanKosong(tahun) {
  return tahun === SEMUA_TAHUN ? "Tidak ada data" : `Tidak ada cuti tahun ${tahun}`;
}

export default function FilterTahunRiwayat({ rows, value, onChange }) {
  const daftar = [...new Set([tahunIni(), ...rows.map(tahunCuti).filter(Boolean)])].sort().reverse();
  return (
    <div className="flex items-center gap-2 mb-3">
      <label className="text-xs font-semibold text-gray-600 uppercase">Tahun</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="border border-gray-300 rounded px-2 py-1 text-sm outline-none focus:border-blue-400"
      >
        {daftar.map((t) => (
          <option key={t} value={t}>{t}</option>
        ))}
        <option value={SEMUA_TAHUN}>Semua</option>
      </select>
    </div>
  );
}
